import {
    calculateJustifiedGridLayout,
    isJustifiedGridRowComplete,
    validateJustifiedGridLayoutOptions,
    type JustifiedGridLayout,
    type JustifiedGridLayoutOptions
} from '../../SharedFrontend/src/justified-grid-layout';

export type LoopingGridLayout = {
    sourceImageIndexes: number[];
    layout: JustifiedGridLayout;
};

type LoopingGridLayoutOptions = JustifiedGridLayoutOptions;

export function calculateLoopingGridLayout(options: LoopingGridLayoutOptions): LoopingGridLayout {
    const {
        aspectRatios,
        usableWidth,
        gap,
        targetRowHeight,
        minimumItemsPerRow,
        maximumItemsPerRow,
        minimumItemSize
    } = options;

    if (aspectRatios.length === 0) return { sourceImageIndexes: [], layout: { items: [], rows: [], contentHeight: 0 } };
    validateJustifiedGridLayoutOptions(options);

    const sourceImageIndexes: number[] = [];
    const rowBoundaryItemCountByPhase = new Map<number, number>();
    rowBoundaryItemCountByPhase.set(0, 0);
    let activeRowAspectSum = 0;
    let activeRowItemCount = 0;

    while (true) {
        const sourceImageIndex = sourceImageIndexes.length % aspectRatios.length;
        sourceImageIndexes.push(sourceImageIndex);
        activeRowAspectSum += aspectRatios[sourceImageIndex];
        activeRowItemCount++;

        if (!isJustifiedGridRowComplete(activeRowAspectSum, activeRowItemCount, options)) continue;
        activeRowAspectSum = 0;
        activeRowItemCount = 0;

        const nextPhase = sourceImageIndexes.length % aspectRatios.length;
        const previousItemCountAtPhase = rowBoundaryItemCountByPhase.get(nextPhase);
        if (previousItemCountAtPhase == null) {
            rowBoundaryItemCountByPhase.set(nextPhase, sourceImageIndexes.length);
            continue;
        }

        const cycleSourceImageIndexes = sourceImageIndexes.slice(previousItemCountAtPhase);
        const cycleLayout = calculateJustifiedGridLayout({
            aspectRatios: cycleSourceImageIndexes.map(index => aspectRatios[index]),
            usableWidth,
            gap,
            targetRowHeight,
            minimumItemsPerRow,
            maximumItemsPerRow,
            minimumItemSize
        });

        return {
            sourceImageIndexes: cycleSourceImageIndexes,
            layout: cycleLayout
        };
    }
}
